// extracted by mini-css-extract-plugin
export default {"HeaderMenuContainer":"styles_HeaderMenuContainer__GSUPc","container":"styles_container__7ih-C","menuButton":"styles_menuButton__Qc74r","content":"styles_content__Nc7sC"};